import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const settingsApi = createApi({
  reducerPath: 'settings',

  baseQuery: createBaseQueryWithReauth('/settings'),
  tagTypes: ['Settings'],

  endpoints: builder => ({
    getProfile: builder.query({
      query: () => ({
        url: `/profile`,
        method: 'GET',
      }),
      providesTags: ['Settings'],
    }),




    editProfile: builder.mutation({
      query: ({ ...data }) => ({
        url: `/profile`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Settings'],
    }),


  }),
});

export const {
  useGetProfileQuery,

  useEditProfileMutation,

  useBagMutation,
} = settingsApi;
